<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
                <router-link to="/stock/onhands">
                {{$t('stock_on_hand_list')}}
                </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{$t('stock_on_hand_create')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="save"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card n_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="blue">{{$t('item_name')}}</label>
                                <div>
                                    <AuthCompleted @select="onSelect($event)"></AuthCompleted>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="blue">{{$t('qty')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="beginStock" readonly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <hr>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group blue">
                                {{$t('branch')}}
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group blue">
                                {{$t('begin_stock')}}
                            </div>
                        </div>
                    </div>
                    <div class="row" v-for="(ret,index) in lines" :key="index">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <input type="text" class="form-control form-control-sm" v-model="ret.BranchName" readonly/>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="number" class="form-control form-control-sm" v-model="ret.BeginStock"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { AuthCompleted } from '../Item';
import Swal from 'sweetalert2';
export default {
    components: { AuthCompleted },
    data(){
        return {
            itemId: '',
            beginStock: 0,
            lines: []
        }
    },
    methods: {
        onSelect(e){
            var loading = this.$loading.show();
            this.itemId = e.data.Id;
            this.beginStock = e.data.BeginQty;
            this.$api().post('stock/onhand/items', { Id: this.itemId }).then(res => {
                if(this.$isValid(res)){
                    this.lines = res.data.Json.StockOnHands;
                }
            }).finally(function() { loading.hide(); });
        },
        save(){
            if(this.itemId == '' || this.itemId == null){
                Swal.fire('សារបញ្ជាក់', 'សូមជ្រើសរើសមុខទំនិញ', 'warning');
            }else if(!this.isValidStock()){
                Swal.fire('សារបញ្ជាក់', 'សូមពិនិត្យចំនួនស្តុកត្រូវតែស្មើរនឹង' + this.beginStock, 'warning');
            }else{
                var loading = this.$loading.show();
                this.$api().post('stock/onhand/save', this.lines).then(res => {
                    if(this.$isValid(res)){
                        this.$router.push('/onhands');
                    }
                }).finally(function() { loading.hide(); });
            }
        },
        isValidStock(){
            var total = 0;
            this.lines.forEach(element => {
                total += Number(element.Quantity);
            });
            return this.beginStock == total;
        }
    }
}
</script>